import React from 'react';

import PropTypes from 'prop-types';
import { TextInput } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';

const TankHeight = ({ dataField, setDataField, error }) => {
  const {
    iotOrderDetailsSection: { tankHeight },
    modalForm: { fieldRequiredMessage }
  } = useLocalizedStringsContext();
  const fieldHasError = error && !dataField.valueTankHeight;

  return (
    <TextInput
      label={tankHeight}
      type="text"
      value={dataField.valueTankHeight}
      validation={fieldHasError ? 'error' : undefined}
      feedback={fieldHasError ? fieldRequiredMessage : undefined}
      onChange={(value) => {
        const regex = new RegExp('^[1-9]');
        const fieldValue = regex.test(+value) ? value : '';
        setDataField({ ...dataField, valueTankHeight: fieldValue });
      }}
    />
  );
};

TankHeight.propTypes = {
  dataField: PropTypes.shape({
    valueTankNumber: PropTypes.string,
    valueTankName: PropTypes.string,
    valueTankProduct: PropTypes.string,
    valueTankProductOther: PropTypes.string,
    valueTankType: PropTypes.string,
    valueTankHeight: PropTypes.string,
    valueTankLength: PropTypes.string,
    valueTankCapacity: PropTypes.string,
    valueTankMaterial: PropTypes.string,
    valueTankSensorType: PropTypes.string,
    valueTankPortSize: PropTypes.string,
    valueTankOptionalStand: PropTypes.string
  }).isRequired,
  setDataField: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired
};

export default TankHeight;
